"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasePropertyInputCurrency = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _react = _interopRequireWildcard(require("react"));

var _atom = require("atom");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _parseCurrencyValue = _interopRequireDefault(require("customer-data-objects-ui-components/formatting/parseCurrencyValue"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _get = _interopRequireDefault(require("transmute/get"));

var _ConnectReferenceResolvers = _interopRequireDefault(require("reference-resolvers/ConnectReferenceResolvers"));

var _ReferenceObjectTypes = _interopRequireDefault(require("reference-resolvers/constants/ReferenceObjectTypes"));

var _utils = require("reference-resolvers/utils");

var _RecordTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/RecordTypesType"));

var _ProvideReferenceResolvers = _interopRequireDefault(require("reference-resolvers/ProvideReferenceResolvers"));

var _MultiCurrencyInformationResolver = _interopRequireDefault(require("reference-resolvers/resolvers/MultiCurrencyInformationResolver"));

var _WithClassWrapper = _interopRequireDefault(require("customer-data-objects-ui-components/hoc/WithClassWrapper"));

var _UICurrencyInput = _interopRequireDefault(require("UIComponents/input/UICurrencyInput"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var propTypes = {
  // TODO: multiCurrencyCurrencyCode is deprecated, try to remove uses if possible
  multiCurrencyCurrencyCode: _react.PropTypes.string,
  nextPipeline: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  placeholder: _react.PropTypes.string,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  resolvers: _react.PropTypes.object,
  subject: _react.PropTypes.oneOfType([_RecordTypesType.default, _react.PropTypes.instanceOf(_immutable.Map)]),
  value: _react.PropTypes.node
};

var PropertyInputCurrency =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PropertyInputCurrency, _PureComponent);

  function PropertyInputCurrency(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputCurrency);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputCurrency).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      currencyCode: null
    };
    return _this;
  }

  (0, _createClass2.default)(PropertyInputCurrency, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var resolver = this.props.resolvers[_ReferenceObjectTypes.default.MULTI_CURRENCY_INFORMATION];

      if (resolver) {
        this.referenceAtom = resolver.byId('default');
        (0, _atom.watch)(this.referenceAtom, this.handleMultiCurrencyInfoChange);
        this.handleMultiCurrencyInfoChange((0, _atom.deref)(this.referenceAtom));
      } else {
        this.setState({
          currencyCode: 'USD'
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.referenceAtom) {
        (0, _atom.unwatch)(this.referenceAtom, this.handleMultiCurrencyInfoChange);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.refs.input) {
        this.refs.input.focus();
        this.refs.input.select();
      }
    }
  }, {
    key: "getCurrencyCode",
    value: function getCurrencyCode() {
      var _this$props = this.props,
          multiCurrencyCurrencyCode = _this$props.multiCurrencyCurrencyCode,
          name = _this$props.property.name,
          subject = _this$props.subject;
      var currencyCode = this.state.currencyCode;
      var dealCurrencyCode = (0, _ImmutableModel.getProperty)(subject, 'deal_currency_code') || (0, _get.default)('deal_currency_code', subject); // To support backwards compatibility use the currency code from props if
      // its provided

      var resolvedCurrencyCode = multiCurrencyCurrencyCode || currencyCode;
      return name === 'amount' ? dealCurrencyCode || resolvedCurrencyCode : resolvedCurrencyCode;
    }
  }, {
    key: "handleMultiCurrencyInfoChange",
    value: function handleMultiCurrencyInfoChange(reference) {
      if ((0, _utils.isResolved)(reference)) {
        this.setState({
          currencyCode: (0, _getIn.default)(['referencedObject', 'currencyCode'], reference)
        });
      }

      if ((0, _utils.isError)(reference)) {
        this.setState({
          currencyCode: 'USD'
        });
      }
    }
  }, {
    key: "getTransferrableProps",
    value: function getTransferrableProps() {
      var _this$props2 = this.props,
          __baseUrl = _this$props2.baseUrl,
          __caretRenderer = _this$props2.caretRenderer,
          __isInline = _this$props2.isInline,
          __isExpandableTextInputEnabled = _this$props2.isExpandableTextInputEnabled,
          __getProperty = _this$props2.getProperty,
          __objectType = _this$props2.objectType,
          __onCancel = _this$props2.onCancel,
          __onInvalidProperty = _this$props2.onInvalidProperty,
          __propertyIndex = _this$props2.propertyIndex,
          __propertyInputComponentConfig = _this$props2.propertyInputComponentConfig,
          __readOnlySourceData = _this$props2.readOnlySourceData,
          __resolver = _this$props2.resolver,
          __resolvers = _this$props2.resolvers,
          __showError = _this$props2.showError,
          __showPlaceholder = _this$props2.showPlaceholder,
          __subject = _this$props2.subject,
          __subjectId = _this$props2.subjectId,
          __secondaryChanges = _this$props2.secondaryChanges,
          __onSecondaryChange = _this$props2.onSecondaryChange,
          __wrappers = _this$props2.wrappers,
          __onTracking = _this$props2.onTracking,
          __isRequired = _this$props2.isRequired,
          transferrableProps = (0, _objectWithoutProperties2.default)(_this$props2, ["baseUrl", "caretRenderer", "isInline", "isExpandableTextInputEnabled", "getProperty", "objectType", "onCancel", "onInvalidProperty", "propertyIndex", "propertyInputComponentConfig", "readOnlySourceData", "resolver", "resolvers", "showError", "showPlaceholder", "subject", "subjectId", "secondaryChanges", "onSecondaryChange", "wrappers", "onTracking", "isRequired"]);
      return transferrableProps;
    }
  }, {
    key: "render",
    value: function render() {
      var currency = this.getCurrencyCode();
      var transferrableProps = this.getTransferrableProps();

      if (!currency) {
        // render UINumberInput if currency is loading, if it fails to load will fall back on USD either way
        return _react.default.createElement(_UINumberInput.default, (0, _extends2.default)({}, transferrableProps, {
          value: (0, _parseCurrencyValue.default)({
            value: this.props.value
          }),
          onChange: this.props.onChange,
          ref: "input"
        }));
      }

      return _react.default.createElement(_UICurrencyInput.default, (0, _extends2.default)({}, transferrableProps, {
        value: (0, _parseCurrencyValue.default)({
          value: this.props.value,
          currency: currency
        }),
        currency: currency,
        onChange: this.props.onChange,
        ref: "input"
      }));
    }
  }]);
  return PropertyInputCurrency;
}(_PureComponent2.default);

exports.BasePropertyInputCurrency = PropertyInputCurrency;
PropertyInputCurrency.propTypes = propTypes;
var getResolvers = (0, _ConnectReferenceResolvers.default)(function (resolvers) {
  return {
    resolvers: resolvers
  };
});

var _default = (0, _ProvideReferenceResolvers.default)((0, _defineProperty2.default)({}, _ReferenceObjectTypes.default.MULTI_CURRENCY_INFORMATION, _MultiCurrencyInformationResolver.default), getResolvers((0, _WithClassWrapper.default)(PropertyInputCurrency), {
  forwardRef: true
}), {
  forwardRef: true,
  mergeResolvers: true
});

exports.default = _default;